import React, { FC } from 'react';
import Typography from 'src/common/components/Typography';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import SearchHero from 'src/common/components/Search/SearchHero';
import styles from './DlpHeader.module.scss';

type DlpHeaderProps = {
  title: React.ReactElement;
  subTitle: React.ReactElement;
};

const DlpHeader: FC<DlpHeaderProps> = ({
  title,
  subTitle,
}) => (
  <PitchPageLayout
    backgroundColor="ivory"
    variant="headerWithSearch"
    outerChildren={(
      <div className={styles.searchBar}>
        <SearchHero variant="hero" />
      </div>
    )}
  >
    <div className={styles.header}>
      <div className={styles.title}>
        <Typography
          type="h1"
          weight="semibold"
        >
          {title}
        </Typography>
      </div>
      <div className={styles.subTitle}>
        <Typography
          type="h2"
          size="body-l"
          weight="regular"
        >
          {subTitle}
        </Typography>
      </div>
    </div>
  </PitchPageLayout>
);

export default DlpHeader;
